export class Campaign {
  constructor(
    public campaignId?: string,
    public campaignName?: string,
    public campaignDesc?: string,
    public campaignMainCountry?: string,
    public campaignTimeZone?: string,
    public campaignCurrencyCode?: string,
    public brandName?: string,
    public skuType?: string,
    public campaignGrossBudget?: number,
    public campaignStartDt?: number,
    public campaignEndDt?: number,
    public campaignCostBasis?: number,
    public campaignCostValue?: number,
    public campaignObjective?: string,
    public campaignObjectiveValue?: number,
    public targetingAgeFrom?: number,
    public targetingAgeTo?: number,
    public targetingIncomeCurrencyFrom?: number,
    public targetingIncomeCurrencyTo?: number,
    public targetingGender?: string,
    public campaignImpressionAttributionWindow?: number,
    public marketedAsGroup?: boolean,
    public isCollectSample?: boolean,
    public isReceiveFromCds2?: boolean,
    public isSendToCds2?: boolean,
    public createTime?: number,
    public providerId?: string,
    public clientId?: string,
    public segment?: string,
    public segmentCategory?: string,
    public campaignType?: any,
    public providerDetail?: Object,
    public pinpoint?: string,
    public isEmail?: boolean,
    public isPhone?: boolean,
    public isSms?: boolean,
    public isWhatsapp?: boolean,
    public subjectContent?: string,
    public emailTemplateHtmlContent?: string,
    public emailTemplateTextContent?: string,
    public file?:Object,
    public iconUrl?: string,
    public bannerUrl?: string,
    public prizeUrl?: string,
    public userTerm?: string,
    public privacyPolicy?: string,
    public onlyDash?: boolean | string,
    public ngpsCfgId?: string,
  ) { }
}



// WEBPACK FOOTER //
// ./src/app/modules/campaign/campaign.model.ts